import { render, staticRenderFns } from "./WelcomeCarouselDemo.vue?vue&type=template&id=993dc3a4&scoped=true&"
import script from "./WelcomeCarouselDemo.vue?vue&type=script&lang=js&"
export * from "./WelcomeCarouselDemo.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCarouselDemo.vue?vue&type=style&index=0&id=993dc3a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993dc3a4",
  null
  
)

export default component.exports